import type { LoginUserVo } from "types/openapi/auth";
import { defineStore } from "pinia";
import { getTokenByTicket } from "@/api/app";
import router from "@/router";
import { useCommonStore } from "./common";
import { usePermissionStore } from "./permission";

interface IAppStore {
  collapsed: boolean;
  token: string;
  userInfo: LoginUserVo;
  allianceList: any[];
  alliance: any;
}

export const useAppStore = defineStore(
  "app",
  () => {
    const store: IAppStore = reactive({
      collapsed: false,
      token: "",
      userInfo: {},
      allianceList: [],
      alliance: null,
    });

    const isBType = computed(() => {
      return store.alliance?.type === 1;
    });
    const isBAdmin = computed(() => {
      return store.alliance?.badmin;
    });
    const isAdmin = computed(() => {
      return store.alliance?.admin;
    });
    const curAllianceCode = computed(() => {
      return store.alliance?.allianceCode;
    });
    function toggleCollapsed() {
      store.collapsed = !store.collapsed;
    }

    async function loginSuccess(ticket: string) {
      const { data } = await getTokenByTicket({
        ticket,
        redirectUrl: window.location.href,
      });
      const { tokenName, tokenValue } = data?.data || {};
      store.token = `${tokenName}=${tokenValue}`;
      store.userInfo = data?.data;
      window.$message?.success("登录成功！");
      router.push({
        path: "/",
      });
    }
    function clear() {
      store.token = "";
      store.userInfo = {};
      store.allianceList = [];
      store.alliance = null;
      usePermissionStore()?.clear();
      useCommonStore()?.clear();
    }
    async function refreshAlliance() {
      const { getJoinAllianceList } = await import("@/api/alliance");
      const { data: res } = await getJoinAllianceList({ pageNum: 1, pageSize: 100, sortJoinTime: 0 });
      const list = res?.data?.data ?? [];
      store.allianceList = list;
      const match = list.find((a: any) => a.allianceCode === store.alliance?.allianceCode);
      store.alliance = match || store.alliance;
    }
    async function logout() {
      clear();
      router.push({
        path: "/login",
      });
    }
    return {
      ...toRefs(store),
      toggleCollapsed,
      loginSuccess,
      logout,
      isBType,
      isBAdmin,
      isAdmin,
      curAllianceCode,
      refreshAlliance,
    };
  },
  { persist: true },
);
